var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_16",
    "data-name": "Group 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 16,
    height: 16,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lock",
    transform: "translate(2.703 0.984)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M1.036,14.014A1.063,1.063,0,0,1,0,12.927V5.58A5.743,5.743,0,0,1,.418,3.414,5.591,5.591,0,0,1,1.553,1.643,5.261,5.261,0,0,1,3.235.442a5.028,5.028,0,0,1,4.12,0,5.268,5.268,0,0,1,1.681,1.2,5.623,5.623,0,0,1,1.136,1.771,5.708,5.708,0,0,1,.414,2.166v.563l0,.3v6.485A1.058,1.058,0,0,1,9.55,14.014Z",
    transform: "translate(0.002 0.009)",
    fill: "none",
    stroke: "#06233d",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M.423,1.689v1.4a.5.5,0,0,0,.991,0v-1.4a.907.907,0,0,0,.42-.769A.917.917,0,0,0,0,.917.927.927,0,0,0,.423,1.689Z",
    transform: "translate(4.38 7.827)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35258",
    "data-name": "Path 35258",
    d: "M0,7.017H10.465",
    transform: "translate(0 -1)",
    fill: "none",
    stroke: "#06233d",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.8fc9139441eca5025d699ab1604c29a1.svg";
export { ForwardRef as ReactComponent };